import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {

    private api = `${environment.api}authorization`;

  get profileId(): string {
    return localStorage.getItem('profileId') || '';
  }
  get token(): string {
    return localStorage.getItem('token') || '';
  }
    
  get headers() {
    return {
      headers: {
        'x-token': this.token
      }
    }
  }

    constructor(
        private http: HttpClient
    ) {}


    // =====================================================
    // OBTENER ADMINISTRADORES
    // =====================================================

    getAdministrators(): Observable<any> {

        return this.http.get(
            `${this.api}/administrators`
        );

    }


    // =====================================================
    // SOLICITAR AUTORIZACIÓN
    // =====================================================

    requestAuthorization(
        adminId: number,
        reason?: string
    ): Observable<any> {

        return this.http.post(
            `${this.api}/request`,
            {
                adminId,
                reason: reason || null
            },
            this.headers
        );

    }


    // =====================================================
    // CONSULTAR ESTADO
    // =====================================================

    getAuthorizationStatus(
        authorizationId: number
    ): Observable<any> {

        return this.http.get(
            `${this.api}/status/${authorizationId}`
        );

    }


    // =====================================================
    // OBTENER SOLICITUDES PENDIENTES
    // ADMINISTRADOR
    // =====================================================

    getPendingAuthorizations(): Observable<any> {

        return this.http.get(
            `${this.api}/pending`,this.headers
        );

    }


    // =====================================================
    // APROBAR
    // =====================================================

    approveAuthorization(
        authorizationId: number
    ): Observable<any> {

        return this.http.post(
            `${this.api}/approve/${authorizationId}`,
            {},this.headers
        );

    }


    // =====================================================
    // RECHAZAR
    // =====================================================

    rejectAuthorization(
        authorizationId: number,
        reason?: string
    ): Observable<any> {

        return this.http.post(
            `${this.api}/reject/${authorizationId}`,
            {
                reason: reason || null
            },this.headers
        );

    }


    // =====================================================
    // CANCELAR SOLICITUD
    // =====================================================

    cancelAuthorization(
        authorizationId: number
    ): Observable<any> {

        return this.http.post(
            `${this.api}/cancel/${authorizationId}`,
            {},this.headers
        );

    }


    // =====================================================
    // VALIDAR TOKEN JWT
    // =====================================================

    validateToken(
        token: string
    ): Observable<any> {

        return this.http.post(
            `${this.api}/validate`,
            {
                token
            }
        );

    }


    // =====================================================
    // OBTENER AUTORIZACIÓN ACTIVA
    // =====================================================

    getActiveAuthorization(): Observable<any> {

        return this.http.get(
            `${this.api}/active`,this.headers
            
        );

    }


    // =====================================================
    // CANCELAR AUTORIZACIÓN ACTIVA
    // =====================================================

    cancelToken(
        authorizationId: number
    ): Observable<any> {

        return this.http.post(
            `${this.api}/token/cancel`,
            {
                authorizationId
            },this.headers
        );

    }

}